import * as Yup from 'yup'

export const creationCellphoneSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  // CampamentoId: Yup.string().required('Campamento es requerido'),
  NroCelular: Yup.string().required('Nro de Celular es requerido'),
  ProveedorServicio: Yup.string().required('Proveedor de Servicio es requerido'),
  // Modelo: Yup.string().required('Modelo es requerido'),
  // Marca: Yup.string().required('Marca es requerido'),
  Estado: Yup.string().required('Estado es requerido'),
})